export default function cacheFetchData(
  CACHEKEY,
  CACHETIMESTAMPKEY,
  CACHEDURATION = 60
) {
  const CACHE_KEY = CACHEKEY;
  const CACHE_TIMESTAMP_KEY = CACHETIMESTAMPKEY;
  const CACHE_DURATION = CACHEDURATION * 60 * 1000; // دقیقه → میلی‌ثانیه

  const cachedData = localStorage.getItem(CACHE_KEY);
  const cachedTimestamp = Number(localStorage.getItem(CACHE_TIMESTAMP_KEY)); // تبدیل به عدد
  const now = Date.now();

  if (cachedData && cachedTimestamp && now - cachedTimestamp < CACHE_DURATION) {
    return JSON.parse(cachedData);
  } else {
    return null;
  }
}
